<div class="container">
  <div class="row">
    <section class="col-md-7">
      <div class="row">
        <h1 class="c11n-text-2xl-headline margin-bottom-2 col-md-12" data-cy="pageTitle" [innerHtml]="content.pageTitle"></h1>
      </div>
      <p class="c11n-text-md c11n-space-stack-4x" data-cy="pageSubTitle" [innerHTML]="content.pageSubtitle"></p>
      <vgim-taxes
        [showErrorWhenInvalid]="shouldTaxesErrorShow"
        [showInnerErrorWhenInvalid]="shouldTaxableIncomeErrorShow"
        [isTaxableAccountType]="true"
      ></vgim-taxes>
      <vgim-retirement-age
        [birthDate]="birthDate$ | async"
        [employmentStatus]="employmentStatus"
        [showValidationErrors]="shouldRetirementAgeErrorShow"
      >
      </vgim-retirement-age>
      <section data-cy="disclaimer" class="taxes-disclaimers-wrapper">
        <div class="c11n-text-sm taxes-disclaimers-wrapper">
          <span [innerHTML]="openChoiceCommonContent.disclaimer.part1"></span>
          <span [innerHTML]="openChoiceCommonContent.disclaimer.part2"></span>
          <a c11n-link [variant]="'secondary-reinforced'" [fontWeight]="'normal'" [href]="openChoiceCommonContent.disclaimer.linkHref">{{ openChoiceCommonContent.disclaimer.linkText }}</a>
          <span [innerHTML]="openChoiceCommonContent.disclaimer.part3"></span>
        </div>
      </section>
      <vgim-secure-link></vgim-secure-link>
    </section>
    <div class="col-md-1"></div>
    <section class="col-md-4">
      <c11n-button id="taxFilingRetirementContinueButton" [labelText]="openChoiceCommonContent.continueButton" [fullWidth]="true"
      (clickEvent)="continue()"></c11n-button>
      <app-cancel [isOpenChoice]="true"></app-cancel>
      <app-feedback-survey></app-feedback-survey>
    </section>
  </div>
</div>
